import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const IndividualProjectsOverviewStyles = css`
  ${MainStyles}
  .individual-projects-overview {
    display: flex;
    flex-direction: column;
    padding: 50px 32px 27px 32px;
    width: 100%;
    gap: 23px;
    background-image: linear-gradient(62.66791662408684deg, #2c3f3d 0%, #2c3f3d 99.99999999999984%);
  }
  .row {
    display: flex;
    gap: 18px;
  }
  .title {
    height: 40px;
    display: flex;
    gap: 16px;
    align-items: baseline;
  }
  .tile-title {
    color: var(--white-smoke);
    text-align: left;
    font-size: 36px;
  }

  .tile-sub-title {
    color: var(--cascade-silver);
    text-align: left;
    font-size: 22px;
  }
  .box {
    display: flex;
    gap: 16px;
  }
  .description {
    width: 25%;
    color: var(--cascade-light-grey);
    text-align: left;
    line-height: 26px;
    font-size: 18px;
    padding-right: 16px;
  }

  .table-columns {
    width: 25%;
    border-radius: 6px;
    border: 1px solid rgba(var(--white), 0.15);
    box-sizing: border-box;
    background-color: var(--cascade-dark-green);
    overflow: auto;
  }

  .single-column {
    width: 75%;
    border-radius: 6px;
    border: 1px solid rgba(var(--white), 0.15);
    box-sizing: border-box;
    background-color: var(--cascade-dark-green);
    overflow: auto;
  }

  .overview-table-header {
    font-size: 18px;
    padding: 16px 0px 8px 16px;
    color: var(--white-smoke);
    text-align: left;
    line-height: 40px;
    background-color: var(--cascade-dark-green);
    position: sticky;
    z-index: 1;
    top: 0;
  }

  .overview-table-header:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: rgba(var(--white-rgb), 0.29);
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  .table-row {
    display: flex;
    min-height: 42px;
    border-bottom: 1px solid rgba(var(--white-rgb), 0.15);
    color: rgba(var(--white-rgb), 0.84);
    text-align: left;
    font-size: 14px;
    padding: 0 16px;
    align-items: center;
  }

  .table-row .right-span {
    display: flex;
    align-items: center;
    margin-left: auto;
    color: var(--primary-color);
    text-align: right;
  }

  .table-row .left-span {
    display: flex;
    align-items: center;
  }

  .table-row .right-span-button {
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-left: auto;
    text-align: right;
    min-width: 114px;
    height: 26px;
    border-radius: 2px;
    border: 1px solid var(--completed);
    background-color: rgba(var(--completed-rgb), 0.29);
    color: var(--white);
    line-height: normal;
    justify-content: center;
  }

  .table-row .right-span-button#GREEN_BUTTON {
    border: 1px solid var(--completed);
    background-color: rgba(var(--completed-rgb), 0.29);
  }

  .table-row .right-span-button#YELLOW_BUTTON {
    border: 1px solid var(--yellow);
    background-color: rgba(var(--yellow-rgb), 0.3);
  }

  .table-row .right-span-button#RED_BUTTON {
    border: 1px solid var(--error);
    background-color: rgba(var(--error-rgb), 0.3);
  }

  .watchlistButton {
    position: fixed;
    right: 16px;
  }
`;
